import template from './loginForm.html';

/*@ngInject*/
function LoginForm(loginService) {
    var loginForm = this;
    loginForm.loginData = {
        agencyId: '',
        userName: '',
        password: ''
    };

    loginForm.isLoginFailed = false;

    loginForm.isLoading = false;

    loginForm.login = login;

    function login() {
        loginForm.isLoginFailed = false;
        loginForm.isLoading = true;
        loginService.login(loginForm.loginData)
            .catch(() => {
                onLoginFailed();
                loginForm.isLoading = false;
            });
    }

    function onLoginFailed() {
        loginForm.isLoginFailed = true;
    }
}

export default {
    templateUrl: template,
    controller: LoginForm,
    controllerAs: 'loginForm'
};





/** WEBPACK FOOTER **
 ** ./src/main/assets/app/login/components/form/loginFormComponent.js
 **/